import { createSelector } from "reselect";
import get from "lodash/get";

const selectState = (state) => state.payment;

export const getSubscriptionPlans = createSelector(selectState, (payment) =>
  get(payment, "subscriptionPlans", [])
);

export const getBillingHistory = createSelector(selectState, (payment) => {
  return get(payment, "billingHistory", []);
});

export const getNextPlan = createSelector(selectState, (payment) =>
  get(payment, "nextSubscriptionPlan", {})
);
